<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        لیست فاکتورها
        <template v-slot:avatar>
          <q-icon name="list"/>
        </template>
        <template v-slot:action v-if="isDialog">
          <q-btn flat round icon="print" @click="loadReport"/>
          <q-btn flat round icon="close" v-close-popup/>
        </template>
      </q-banner>
      <q-toggle v-model="saleKind"
                :false-value="true"
                :true-value="false"
                :label="saleKind?'لیست فاکتورهای برگشتی':'لیست فاکتورها'"/>
      <q-toggle v-model="withoutReturn"
                :false-value="true"
                :true-value="false"
                :label="saleKind?'لیست فاکتورهایی که درخواست برگشت آن ها ثبت شده است':'لیست فاکتورها'"/>
    </q-card-section>
    <q-card-section class="no-padding">
      <FactorHistory v-if="$q.screen.lt.md" :order-history-list.sync="items" :is-dialog="false"/>
      <FactorHistoryDesktop v-if="!$q.screen.lt.md" :order-history-list.sync="items" :is-dialog="false"/>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import FactorHistory from "@/components/Factor/FactorHistory";
import EventBus from "@/event-bus";
import FactorHistoryDesktop from "@/components/Factor/FactorHistoryDesktop";

export default {
  name: "FactorsList",
  components: {FactorHistoryDesktop, FactorHistory},
  props: {
    isDialog: {
      type: Boolean,
      required: false,
      default: () => false
    },
    startDate: {
      type: String,
      required: false,
      default: () => undefined
    },
    endDate: {
      type: String,
      required: false,
      default: () => undefined
    },
    userId: {
      type: Number,
      required: false,
      default: () => undefined
    }
  },
  data() {
    return {
      items: [],
      saleKind: true,
      withoutReturn: true
    }
  },
  methods: {
    ...mapActions({
      getFactorList: 'Orders/getFactors',
      getNoReturnFactor: 'Orders/loadFactorWithNoReturn',
      getAgentNotFactorPay: 'Agents/getAgentNotPayFactor'
    }),
    async loadReport() {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات بازاریابان/گزارش لیست فاکتورهای تسویه نشده یک کارشناس?rs:Format=PDF&Sale_Kind=${this.saleKind ? 1 : -1}&Sale_Nums=${this.items.map(x => x.Sale_Num)}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    loadDate() {
      if (this.startDate && this.endDate && this.userId) {
        this.getAgentNotFactorPay({
          startDate: this.startDate.replaceAll('/', '-'),
          endDate: this.endDate.replaceAll('/', '-'),
          userId: this.userId
        }).then((res) => {
          this.items = res
          EventBus.$emit('invoke-factor-list', this.items);
        })
      } else {
        this.getFactorList({
          cs_id: -1,
          saleKind: this.saleKind === true ? 1 : -1
        }).then((res) => {
          this.items = res
          EventBus.$emit('invoke-factor-list', this.items);
        })

      }
    }
  },
  watch: {
    saleKind: function () {
      this.loadDate()
    },
    withoutReturn: function (newValue) {
      if (newValue === false) {
        this.getNoReturnFactor().then((res) => {
          this.items = res
          EventBus.$emit('invoke-factor-list', this.items);
        })
      } else {
        this.loadDate()
      }
    }
  },
  created() {
    this.loadDate()
  }
}
</script>

<style scoped>
.fixed-header-position {
  position: sticky;
  top: 50px;
  z-index: 1000;
}
</style>